module.exports = __webpack_public_path__ + "static/media/hoveredFeaturePin.7bdf8ba8.svg";